import React, { useEffect, useState, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import CardSection from 'components/sales/cardSection/cardSection';
import DivLayout from 'components/sales/divLayout/divLayout';
import { Button } from 'react-bootstrap';
import Config from "services/config/config";
import axios from "services/interceptor/Interceptor";
import { toast } from 'react-toastify';

const ContractAssets = ({
  history,
  match,
  getgatesByContratctId,
  siteGatesData
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [gateData, setGatesData] = useState([]);
  const [isValid, setIsValid] = useState(false);
  const [mappingComplete, setMappingComplete] = useState(0);
  const [isDisabled, setIsDisabled] = useState(false);
  
  
  console.log('PAGE:: CONTRACT GATES');

  useEffect(() => {
     if(match.params.lead_id != null || match.params.lead_id != undefined) {
        (async () => {
          await getgatesByContratctId(match.params.id);
        })();
     }
  },[match.params.lead_id]);

  useEffect(() => {
      if(siteGatesData) {
        setGatesData(siteGatesData?.data);
        setIsValid(siteGatesData?.isValid);
        setMappingComplete(siteGatesData?.all_complete);
      }
  },[siteGatesData]);
  console.log('gate data ' + JSON.stringify(siteGatesData));

  const handleCompleteAssetMapping = () => {
      let site_id = match.params.id;
      if(site_id && site_id !== undefined) {
        (async () => {
          setIsDisabled(true);
          setIsLoading(true);
          const url = `${Config.installation.markCompleteAssetMappingSite}?site_id=${site_id}`;
          const { data } = await axios.post(url);
          if(data && data?.response.data == true) {
            toast.success('Updated Successfully.');
            setIsLoading(false);
            setTimeout((function() {
              window.location.reload();
            }), 3000);
          } else {
            setIsLoading(false);
            toast.error('Something went wrong, please try again.');
          }
          setIsLoading(false);
        })();
      } 
  }

  const headerBtns = () => {
    return (
        <>
        {isValid == true && mappingComplete === 0 &&
          <Button
                disabled={isDisabled}
                onClick={() => handleCompleteAssetMapping()}
                className="filter-hamburger btn btn-transparent filter-btn-dir filters_direction filters-section"
            >
            <b className="site_filters" style={{width:"max-content"}}>
                {'Complete'}
            </b>
          </Button>
        }   
        {mappingComplete === 1 &&
          <span style={{color:'green'}}>Mapping Completed</span>
        } 
        </>
    );
  };

  return (
    <Layout
      title={localization.sitesGates}
      isLoading={isLoading}
      Buttons={headerBtns}
      isGoback
      linkUrl={`${baseUrl}/site-listing`}
    >
    {gateData && gateData?.length > 0 && gateData.map((value,index) => {
      return (
        <CardSection title={localization.solution + ' ' + (index+1)} key={index}>
            <div className="details-listing">
              <DivLayout
                  heading={localization.gate}
                  data={value.gate_name}
              />
              <DivLayout
                  heading={localization.gateDescription}
                  data={value.detail}
              />
              {value.found_asset_mapping  && value.found_asset_mapping !== null ? (
                <div className='col-md-12' style={{'padding':'15px 0px 15px 0px'}}>
                <a href={`/dashboard/mapped-assets/`+value.id +'/'+ value.found_asset_mapping} className='btn btn-primary btn-green-v1'>Mapped Assets</a>
              </div>
              ):<div className='col-md-12' style={{'padding':'15px 0px 15px 0px'}}>
                <a href={`/dashboard/new-site-asset-gate-mapping/`+value.id +'/'+ value.gate_setup_id+'/'+value.lead_id+'/'+match.params.id} className='btn btn-primary btn-red'>Map Asset</a>
                </div>}
            </div>
        </CardSection>        
      )
    })}
    </Layout>
  );
};

export default ContractAssets;
